define('boxes/helpers/email-verification-handlers',['jquery', 'boxes/helpers/verification', 'boxes/helpers/message-popup', 'boxes/helpers/box-loading', 'boxes/helpers/signUpValidation'], function($, verification, messagePopup, boxLoading, signUpValidation) {
    'use strict';

    var doneCallback = undefined;

    function setDoneCallback(doneCallbackRef){
        doneCallback = doneCallbackRef;
    }

    function showErrorTooltip($emailInputElement, errorContent) {
        var $inputContainer = $emailInputElement.parent().parent();
        $inputContainer.addClass('has-error');
        $inputContainer.popover('destroy');
        $inputContainer.popover({
            content: errorContent,
            container: $inputContainer,
            trigger: 'manual',
            placement: 'right'
        }).popover('show');
    }

    function updateEmail($box, $changeFrame, $verifyFrame) {
        var $emailInputElement = $changeFrame.find('input');
        var $newEmail = $emailInputElement.val();
        var $oldEmailElement = $verifyFrame.find('.inner div.container div.col b');
        if ($newEmail === $oldEmailElement.text()) {
            $changeFrame.hide();
            $verifyFrame.show();
            verification.resetChangeFrame($emailInputElement);
            boxLoading.removeLoading($box);
            return;
        }

        if(signUpValidation.isEmailValid($emailInputElement) === false) {
            showErrorTooltip($emailInputElement, $emailInputElement.data('contentError'));
        }

        $.get('/pp?flow=UpdateEmail&PARAM_EMAIL=' + $newEmail, function (data) {
            boxLoading.removeLoading($box);
            if (data.RESULT === 'OK') {
                $emailInputElement.val($newEmail);
                $oldEmailElement.text($newEmail);
                $changeFrame.hide();
                $verifyFrame.show();
                verification.resetChangeFrame($emailInputElement);
            } else {
                showErrorTooltip($emailInputElement, data.PARAM_EMAIL);
            }
        });
    }

    function resendEmail($box, onlyShowError) {
        $.get('/pp?flow=ResendEmailVerification', function (data) {
            boxLoading.removeLoading($box);
            var title, message;
            if (data.RESULT === 'OK') {
                title = data.HEADER;
                message = data.TEXT;
            } else {
                title =  data.ERROR_HEADER;
                message = data.ERROR;
            }

            if (onlyShowError && data.RESULT === 'OK') {
                return;
            }
            messagePopup.show($box, 'message-popup',{
                title: title,
                message: message,
                closeButtonText: data.BUTTON_OK
            });
        });
    }

    function verifyEmail($box, $controller) {
        $.get('/pp?flow=IsEmailVerified', function (data) {
            if(data.RESULT === 'OK') {
                if(doneCallback === undefined){
                    $controller.nextBox();
                } else{
                    doneCallback(data, $box, $controller);
                }
            } else {
                boxLoading.removeLoading($box);
                messagePopup.show($box, 'message-popup',{
                    title: data.ERROR_HEADER,
                    message: data.ERROR,
                    closeButtonText: data.BUTTON_OK
                });
            }
        });
    }

    var emailVerification = {};
    emailVerification.updateEmail = updateEmail;
    emailVerification.verifyEmail = verifyEmail;
    emailVerification.resendEmail = resendEmail;
    emailVerification.setDoneCallback = setDoneCallback;
    return emailVerification;
});





